/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AdditionalCostDtoFromJSON, AdditionalCostDtoToJSON, CarConditionDtoFromJSON, CarConditionDtoToJSON, FileDtoFromJSON, FileDtoToJSON, FuelLevelFromJSON, FuelLevelToJSON, ProtocolTypeFromJSON, ProtocolTypeToJSON, SignaturesDtoFromJSON, SignaturesDtoToJSON, } from './';
export function ProtocolDtoFromJSON(json) {
    return ProtocolDtoFromJSONTyped(json, false);
}
export function ProtocolDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'protocolNumber': !exists(json, 'protocolNumber') ? undefined : json['protocolNumber'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'accepted': !exists(json, 'accepted') ? undefined : (new Date(json['accepted'])),
        'acceptedByEmployeeId': !exists(json, 'acceptedByEmployeeId') ? undefined : json['acceptedByEmployeeId'],
        'acceptedByEmployee': !exists(json, 'acceptedByEmployee') ? undefined : json['acceptedByEmployee'],
        'mileage': !exists(json, 'mileage') ? undefined : json['mileage'],
        'fuelLevel': !exists(json, 'fuelLevel') ? undefined : FuelLevelFromJSON(json['fuelLevel']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'type': !exists(json, 'type') ? undefined : ProtocolTypeFromJSON(json['type']),
        'carCondition': !exists(json, 'carCondition') ? undefined : CarConditionDtoFromJSON(json['carCondition']),
        'additionalCosts': !exists(json, 'additionalCosts') ? undefined : AdditionalCostDtoFromJSON(json['additionalCosts']),
        'additionalEquipment': !exists(json, 'additionalEquipment') ? undefined : json['additionalEquipment'],
        'signatures': !exists(json, 'signatures') ? undefined : SignaturesDtoFromJSON(json['signatures']),
        'documentFile': !exists(json, 'documentFile') ? undefined : FileDtoFromJSON(json['documentFile']),
    };
}
export function ProtocolDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'protocolId': value.protocolId,
        'protocolNumber': value.protocolNumber,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'accepted': value.accepted === undefined ? undefined : (value.accepted.toISOString()),
        'acceptedByEmployeeId': value.acceptedByEmployeeId,
        'acceptedByEmployee': value.acceptedByEmployee,
        'mileage': value.mileage,
        'fuelLevel': FuelLevelToJSON(value.fuelLevel),
        'notes': value.notes,
        'type': ProtocolTypeToJSON(value.type),
        'carCondition': CarConditionDtoToJSON(value.carCondition),
        'additionalCosts': AdditionalCostDtoToJSON(value.additionalCosts),
        'additionalEquipment': value.additionalEquipment,
        'signatures': SignaturesDtoToJSON(value.signatures),
        'documentFile': FileDtoToJSON(value.documentFile),
    };
}
